import React from 'react';

import { Box, Flex, Text } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

type Props = {
  isSelected: boolean;
  onPress: () => void;
  icon: React.ReactNode;
  label: string;
};

const SelectableOption = ({ isSelected, onPress, icon, label }: Props): JSX.Element => {
  const theme = useTheme();

  return (
    <Flex
      webAs="button"
      role="radio"
      aria-checked={isSelected}
      onPress={onPress}
      height="60px"
      alignItems="center"
      justifyContent="flex-start"
      gap="2x"
      p="3x"
      border="2px solid"
      borderRadius="primary"
      width="100%"
      sx={{
        backgroundColor: isSelected
          ? theme.colors.interactive_link.primary_inverse_pressed
          : 'white',
        borderColor: isSelected
          ? theme.colors.interactive_link.primary_base
          : theme.colors.border.primary,
      }}
    >
      <Box flexShrink="0">{icon}</Box>
      <Text
        size="100"
        fontWeight="semibold"
        textColor="primary"
        textAlign="left"
        sx={{ wordBreak: 'break-word' }}
      >
        {label}
      </Text>
    </Flex>
  );
};

export default SelectableOption;
